import isNil from "lodash/isNil";
import { useQuery } from "urql";

import { GetPengurusesDocument } from "../../../../graphql/generated.ts";

interface Props {
  clikDataParentId: number | string | null | undefined;
}

export function usePenguruses({ clikDataParentId }: Props) {
  return useQuery({
    query: GetPengurusesDocument,
    variables: { clikDataParentId: Number(clikDataParentId) },
    pause: isNil(clikDataParentId),
  });
}
